import React from 'react';

const NoMatch = () => (
  <div className="NoMatch">
    <h1>Forbidden</h1>
  </div>
);

export default NoMatch;
